import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <div className="w-16 h-16 md:w-20 md:h-20 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <i className="ri-error-warning-line text-2xl md:text-3xl text-primary-500"></i>
        </div>
        <h1 className="text-xl md:text-2xl font-bold text-foreground-900 mt-6 font-heading">页面未找到</h1>
        <p className="mt-2 text-sm text-foreground-500 font-mono">{location.pathname}</p>
        <p className="mt-4 text-sm text-foreground-600">抱歉，您访问的页面不存在或已被移除</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-6 px-5 py-2.5 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          <i className="ri-arrow-left-line"></i> 返回首页
        </Link>
      </div>
    </div>
  );
}